module.exports = __webpack_public_path__ + "static/TeamHeader-2e5211b935753c46903ba57aa74f46de.jpg";